import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap, catchError, EMPTY, finalize } from 'rxjs';
import { AuditTypeResult } from 'src/app/core-module/models/AuditTypes/audit-type-result';
import { AuditResult } from 'src/app/core-module/models/Audits/audit-result';
import { FlattenedQuestionHolder } from 'src/app/core-module/models/Audits/flattened-question-holder';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { BasicResult } from 'src/app/core-module/models/basic-result';
import { DDL } from 'src/app/core-module/models/ddl';
import { AuditService } from 'src/app/core-module/services/audit.service';
import { ReferenceService } from 'src/app/core-module/services/reference.service';
import { ToastrService } from 'src/app/core-module/services/toastr.service';

@Component({
    selector: 'app-edit-audit',
    templateUrl: './edit-audit.component.html',
    styleUrls: ['./edit-audit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditAuditComponent {

  public audit: FlattenedQuestionHolder = new FlattenedQuestionHolder();
  private originalAudit: FlattenedQuestionHolder;
  public auditTypes: DDL[];
  public frequencies: DDL[];

  public showMainInfo: boolean = true;
  public showEntryOptions: boolean = false;
  public showQuestions: boolean = false;
  public showWorkflow: boolean = false;

  public reloading: boolean = false;
  public isDupe: boolean = false;

  public unsavedChanges: boolean = false;
  public trySave:boolean = false;
  public showActionSectionBar: boolean = true;
  public backDestination: string = "/settings/manage/edit";
  public newAudit: boolean = false;

  constructor(private router: Router, public audits: AuditService, private toastr: ToastrService, private ref: ReferenceService) {
    if (this.router.url == '/settings/manage/new/audit') {
      this.audit = new FlattenedQuestionHolder({ 'AuditID': -1 });
      this.backDestination = "/settings";
      this.originalAudit = structuredClone(this.audit);
      this.newAudit = true;
    } else {
      if (this.router.currentNavigation()?.extras.state!['Audit'] != undefined) {
        this.isDupe = this.router.currentNavigation()?.extras.state!['Duplicate']
        this.audit = this.router.currentNavigation()?.extras.state!['Audit'] as FlattenedQuestionHolder;
        audits.getAudit(this.audit.AuditID, -1).pipe(
          tap((res:AuditResult) => {

            this.addQuestionGUIDs(res.QuestionHolder);
            this.updateCopiedRepeats(res.QuestionHolder);
            this.audit = res.QuestionHolder;
            this.originalAudit = structuredClone(res.QuestionHolder);
            
            this.updateDuplicate();
          })

        ).subscribe();
      }

    }

    audits.getAuditTypes().pipe(
      tap((res:AuditTypeResult) => {
        this.auditTypes = res.Results!;
      })
    ).subscribe();

    ref.getFrequencies().pipe(
      tap((res:DDL[]) => {
        this.frequencies = res;
      })
    ).subscribe()
this.scrollToTop()
  }
  addQuestionGUIDs(FQH:FlattenedQuestionHolder){
    FQH.Questions.forEach(e=>{
      e.GUID = crypto.randomUUID();
    })
  }
  updateDuplicate() {
    if (this.isDupe) {
      this.originalAudit.AuditName = 'Copy of ' + this.audit.AuditName;
      this.originalAudit.AuditID = -1;
      this.audit.AuditID = -1;
      this.audit.AuditName = 'Copy of ' + this.audit.AuditName;
      
    }

  }
  updateCopiedRepeats(FQH:FlattenedQuestionHolder){
    FQH.Questions.forEach(e=>{
      if(e.IsRepeatEnd){
        e.RepeatQuestionIDs.forEach(f=>{
          e.RepeatQuestionGUIDs.push(FQH.Questions.find(g=>{return g.QuestionID == f})!.GUID);
        })
      }
    })
  }
  scrollToTop(){
    window.scroll({ 
           top: 0, 
           left: 0, 
           behavior: 'smooth' 
    });

  }
  reloadAudit() {
    this.reloading = true;
    this.audits.getAudit(this.audit.AuditID, -1).pipe(
      tap((res:AuditResult) => {
        this.addQuestionGUIDs(res.QuestionHolder);
        this.audit = res.QuestionHolder;        
        this.originalAudit = structuredClone(res.QuestionHolder);
        this.reloading = false;
      })
    ).subscribe();
  }

  saveChanges() {
    if (!this.validateSave()) {
      this.toastr.addToastr(new Toastr({ Message: "Please complete required fields", Type: 1 }))
      return;
    }
    this.audit.AuditMetaData.Internal = this.audit.AuditEntryOptions.InternalAudit;
    this.cleanMaxScores();
    this.complianceLimitCheck();
    this.trySave = true;



    this.audits.saveAuditChanges(this.audit).pipe(
      tap((res:BasicResult) => {
        if (res.IsError) {
          this.toastr.addToastr(new Toastr({ Message: "An error occurred, please try again later.", Type: 1 }))
        } else {
          this.audit.AuditID = Number(res.ErrorMessage);
          this.toastr.addToastr(new Toastr({ Message: "Audit saved.", Type: 2 }))
          this.unsavedChanges = false;
          this.reloadAudit();
        }
      }),
      catchError((err:any, n:any) => {
        this.toastr.addToastr(new Toastr({ Message: "An error occurred, please try again later.", Type: 1 }))
        return EMPTY;
      }),
        finalize(()=>{
          this.trySave = false;
        })
    ).subscribe();
  }
  cleanMaxScores(){
    this.audit.Questions.forEach(q=>{
      if(!q.AdvancedMaxScore){
        q.MaxScore = -1;
      }
      if(q.MaxScore <0){
        q.MaxScore = -1;
      }
    })
  }
  complianceLimitCheck(){
    this.audit.Questions.forEach(e=>{
      if(e.ComplianceLimit == null){
        e.ComplianceLimit =-1;
      }
      if(e.MaxScore == null){
        e.AdvancedMaxScore = false;
        this.cleanMaxScores();
      }
    })
  }

  auditChangeCheck(reschdule:boolean) {
    if(reschdule){
          this.resequenceAudit() ;
    }

    this.unsavedChanges = false;
    if (this.audit.AuditName != this.originalAudit.AuditName) {
      this.unsavedChanges = true;
    }
    if (this.audit.AuditInfo.AuditType != undefined) {
      if (this.originalAudit.AuditInfo.AuditType != undefined) {

        if (this.audit.AuditInfo.AuditType.ID != this.originalAudit.AuditInfo.AuditType.ID) {
          this.unsavedChanges = true;
        }
      } else {
        this.unsavedChanges = true;
      }
    }
    if (this.audit.AuditInfo.Frequency != undefined) {
      if (this.originalAudit.AuditInfo.Frequency != undefined) {
        if (this.audit.AuditInfo.Frequency.ID != this.originalAudit.AuditInfo.Frequency.ID) {
          this.unsavedChanges = true;
        }
      } else {
        this.unsavedChanges = true;
      }
    }
    if (this.audit.AuditInfo.FrequencyMultiplier != this.originalAudit.AuditInfo.FrequencyMultiplier) {
      this.unsavedChanges = true;
    }
    if (this.audit.AuditInfo.RevisionNotes != this.originalAudit.AuditInfo.RevisionNotes) {
      this.unsavedChanges = true;
    }
    if (this.audit.AuditInfo.RevisionDate != this.originalAudit.AuditInfo.RevisionDate) {
      this.unsavedChanges = true;
    }
    if (this.audit.AuditInfo.Code != this.originalAudit.AuditInfo.Code) {
      this.unsavedChanges = true;
    }
    if (this.audit.AuditInfo.ReportDescription != this.originalAudit.AuditInfo.ReportDescription) {
      this.unsavedChanges = true;
    }
    if (this.audit.AuditEntryOptions.HideDiary != this.originalAudit.AuditEntryOptions.HideDiary) {
      this.unsavedChanges = true;
    }
    if (this.audit.AuditEntryOptions.HideScore != this.originalAudit.AuditEntryOptions.HideScore) {
      this.unsavedChanges = true;
    }
    if (this.audit.AuditEntryOptions.InternalAudit != this.originalAudit.AuditEntryOptions.InternalAudit) {
      this.unsavedChanges = true;
    }
    if (this.audit.IsEventAudit != this.originalAudit.IsEventAudit) {
      this.unsavedChanges = true;
    }
    if (this.audit.Questions.length != this.originalAudit.Questions.length) {
      this.unsavedChanges = true;
    } else {
      if (this.audit.Questions.length > 0) {
        this.audit.Questions.forEach((q, i) => {
          if (q.Seq != this.originalAudit.Questions[i].Seq) {
            this.unsavedChanges = true;
          }
          if (q.QuestionHeader != this.originalAudit.Questions[i].QuestionHeader) {
            this.unsavedChanges = true;
          }
          if (q.QuestionBody != this.originalAudit.Questions[i].QuestionBody) {
            this.unsavedChanges = true;
          }
          if (q.QuestionType.ID != this.originalAudit.Questions[i].QuestionType.ID) {
            this.unsavedChanges = true;
          }
          if (q.HelpText != this.originalAudit.Questions[i].HelpText) {
            this.unsavedChanges = true;
          }
          if (q.Required != this.originalAudit.Questions[i].Required) {
            this.unsavedChanges = true;
          }
          if (q.AllowNA != this.originalAudit.Questions[i].AllowNA) {
            this.unsavedChanges = true;
          }
          if (q.QuestionAnswers.length != this.originalAudit.Questions[i].QuestionAnswers.length) {
            this.unsavedChanges = true;
          } else {
            if (q.QuestionAnswers.length > 0 && q.QuestionAnswers.length > 0) {
              q.QuestionAnswers.forEach((qa, j) => {
                if (qa.AnswerText != this.originalAudit.Questions[i].QuestionAnswers[j].AnswerText) {
                  this.unsavedChanges = true;
                }
                if (qa.Seq != this.originalAudit.Questions[i].QuestionAnswers[j].Seq) {
                  this.unsavedChanges = true;
                }
                if (qa.ComplianceScore != this.originalAudit.Questions[i].QuestionAnswers[j].ComplianceScore) {
                  this.unsavedChanges = true;
                }
                if (qa.IsNA != this.originalAudit.Questions[i].QuestionAnswers[j].IsNA) {
                  this.unsavedChanges = true;
                }
                if (qa.IsDefault != this.originalAudit.Questions[i].QuestionAnswers[j].IsDefault) {
                  this.unsavedChanges = true;
                }
                if (qa.Actionable != this.originalAudit.Questions[i].QuestionAnswers[j].Actionable) {
                  this.unsavedChanges = true;
                }
              });
            }
          }

        });
      }
    }

  }
  validateSave(): boolean {
    //Type must be valid
    if (!this.audit.AuditInfo.AuditType) {
      return false;
    }
    if (!this.audit.AuditInfo.Frequency) {
      return false;
    }
    if (this.audit.AuditInfo.Frequency.ID == -1) {
      return false;
    }
    if (this.audit.AuditInfo.FrequencyMultiplier == null) {
      return false;
    }
    if (this.audit.AuditInfo.FrequencyMultiplier < 1) {
      return false;
    }
    if (this.audit.AuditInfo.FrequencyMultiplier.toString().indexOf('.') != -1) {
      return false;
    }
    //Audit name required
    if (this.audit.AuditName.length == 0) {
      return false;
    }
    return true;
  }
  resetChanges() {
    if (this.newAudit) {
      var a = new FlattenedQuestionHolder({ 'AuditID': -1 });
      a.AuditInfo.AuditType = new DDL({ "Description": "Please select...", "ID": -1 });
      a.AuditInfo.Frequency = new DDL({ "Description": "Please select...", "ID": -1 });
      this.audit = a;

    } else {
      this.audit = structuredClone(this.originalAudit);
    }
    this.unsavedChanges = false;

  }
  resequenceAudit() {
    this.audit.Questions.sort((a, b) => a.Seq - b.Seq);
    var Seq: number = 1;
    this.audit.Questions.forEach(e => {
      if (e.Active) {
        e.Seq = Seq;
        Seq++;
      }
    });
  }
  showAuditMainInfo() {
    this.showMainInfo = true;
    this.showQuestions = false;
    this.showEntryOptions = false;
    this.showWorkflow = false;
  }

  showAuditEntryOptions() {
    this.showMainInfo = false;
    this.showQuestions = false;
    this.showEntryOptions = true;
    this.showWorkflow = false;
  }

  showAuditQuestions() {
    this.showMainInfo = false;
    this.showQuestions = true;
    this.showEntryOptions = false;
    this.showWorkflow = false;
  }

  showAuditWorkflow() {
    this.showMainInfo = false;
    this.showQuestions = false;
    this.showEntryOptions = false;
    this.showWorkflow = true;
  }
  goBack() {
    this.router.navigateByUrl("/settings/manage/edit");
  }
}
